import React from "react";

const CreateOrder = ({ children }) => {
  return <>{children}</>;
};

export default CreateOrder;
